import { ViatorLogo } from "@/components/yts/PartnerMarks";

/**
 * Official booking-platform attribution. The images belong to their brands;
 * a logo tells guests which platform handles the booking, not that the
 * provider has endorsed or certified Ya Tú Sabes PR.
 */
export const FAREHARBOR_LOGO_URL = "/partner-marks/fareharbor-white-keyline.png";

export function FareHarborLogo({ className = "h-5 w-auto" }) {
  return <img src={FAREHARBOR_LOGO_URL} alt="FareHarbor" className={`${className} max-w-full object-contain drop-shadow-[0_1px_1px_rgba(0,0,0,0.3)]`} loading="lazy" decoding="async" />;
}

export default function BookingPartnerLogo({ provider, className = "" }) {
  const partner = String(provider || "").toLowerCase();
  if (partner === "fareharbor") return <FareHarborLogo className={`h-[18px] w-auto ${className}`} />;
  if (partner === "viator") return <ViatorLogo className={`h-[26px] w-auto ${className}`} />;
  return null;
}
